import React from "react";
import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  HiHome,
  HiOutlineHome,
  HiClipboardList,
  HiOutlineClipboardList,
  HiUser,
  HiOutlineUser,
  HiPlus,
} from "react-icons/hi";
import { BiMedal } from "react-icons/bi";
import isDonationBottomNavHidden from "utils/isDonationBottomNavHidden";

const navBtnClass =
  "flex flex-col items-center justify-center gap-0.5 min-w-0 flex-1 py-2 px-1 text-[10px] sm:text-xs font-medium text-gray-400 dark:text-gray-400 transition-colors";
const activeClass =
  "!text-[#5C7A22] dark:!text-kostebek-300 font-semibold";

/** Atıklarım tab: liste + detay/düzenle aktif; Atık Ekle (add-waste) hariç. */
const isMyWastesNavActive = (pathname) =>
  pathname === "/user-wastes/waste-list" ||
  pathname.startsWith("/user-wastes/waste-list/edit-waste");

const CustomerMobileBottomNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const hideDonation = isDonationBottomNavHidden();

  const fabActive =
    location.pathname === "/user-wastes/waste-list/add-waste" ||
    location.pathname.startsWith("/user-wastes/waste-list/add-waste");

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[100] border-t border-gray-100 dark:border-gray-700 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md pb-[env(safe-area-inset-bottom,0px)]"
      aria-label={t("nav.customerMobile.bottomNavAria")}
    >
      <div className="relative flex items-end justify-between px-1 pt-1 max-w-lg mx-auto">
        <div className="flex flex-1 justify-around items-end">
          <NavLink
            to="/home"
            className={({ isActive }) =>
              classNames(navBtnClass, isActive && activeClass)
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <HiHome className="text-xl shrink-0" />
                ) : (
                  <HiOutlineHome className="text-xl shrink-0" />
                )}
                <span className="truncate w-full text-center leading-tight">
                  {t("nav.home")}
                </span>
              </>
            )}
          </NavLink>
          <NavLink
            to="/user-wastes/waste-list"
            className={classNames(
              navBtnClass,
              isMyWastesNavActive(location.pathname) && activeClass
            )}
          >
            {isMyWastesNavActive(location.pathname) ? (
              <HiClipboardList className="text-xl shrink-0" />
            ) : (
              <HiOutlineClipboardList className="text-xl shrink-0" />
            )}
            <span className="truncate w-full text-center leading-tight">
              {t("nav.myWastes")}
            </span>
          </NavLink>
        </div>

        <div className="relative flex flex-col items-center w-[4.5rem] shrink-0">
          <NavLink
            to="/user-wastes/waste-list/add-waste"
            className={classNames(
              "absolute -top-7 flex items-center justify-center w-14 h-14 rounded-full shadow-lg",
              "bg-[#B6D45A] text-[#3F4D1C]",
              "ring-4 ring-white dark:ring-gray-900",
              "hover:bg-kostebek-500 transition-transform active:scale-95",
              fabActive && "ring-kostebek-200 dark:ring-kostebek-800"
            )}
            aria-label={t("wastes.addTitle")}
          >
            <HiPlus className="text-3xl" />
          </NavLink>
          <span
            className={classNames(
              "text-[10px] sm:text-xs font-medium pb-2 pt-8 text-center leading-tight",
              fabActive
                ? "text-[#5C7A22] dark:text-kostebek-300"
                : "text-gray-400 dark:text-gray-400"
            )}
          >
            {t("nav.customerMobile.addWaste")}
          </span>
        </div>

        <div className="flex flex-1 justify-around items-end">
          {!hideDonation && (
            <NavLink
              to="/donation/donate"
              className={({ isActive }) =>
                classNames(navBtnClass, isActive && activeClass)
              }
            >
              {({ isActive }) => (
                <>
                  <BiMedal
                    className={classNames(
                      "text-xl shrink-0",
                      isActive && "text-[#5C7A22]"
                    )}
                  />
                  <span className="truncate w-full text-center leading-tight">
                    {t("nav.customerMobile.points")}
                  </span>
                </>
              )}
            </NavLink>
          )}
          <NavLink
            to="/my-profile"
            className={({ isActive }) =>
              classNames(navBtnClass, isActive && activeClass)
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <HiUser className="text-xl shrink-0" />
                ) : (
                  <HiOutlineUser className="text-xl shrink-0" />
                )}
                <span className="truncate w-full text-center leading-tight">
                  {t("header.user.profile")}
                </span>
              </>
            )}
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default CustomerMobileBottomNav;
